import React from "react";
export const AvatarStrip = () => {
  return <div className="flex items-center gap-3 pt-4">
      <div className="flex -space-x-3">
        {[1, 2, 3, 4].map(i => <div key={i} className="w-9 h-9 rounded-full border-2 border-white bg-gray-200 ring-2 ring-white/50" style={{
        backgroundImage: `url(https://randomuser.me/api/portraits/${i % 2 === 0 ? 'men' : 'women'}/${i + 10}.jpg)`,
        backgroundSize: "cover"
      }} />)}
      </div>
      <p className="text-sm text-gray-600">
        <span className="font-semibold">Join the</span> financial glow-ups this month
      </p>
    </div>;
};